import React from 'react';
import cn from 'classnames';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import styles from './index.module.scss';
import { colorPrimary } from '~/common/utils';

interface PopupDisclaimerProps {
  className?: string;
  disclaimer?: string;
  customTrigger?: React.ReactNode | string;
  customContent?: boolean;
  contentClassName?: string;
  triggerClassName?: string;
  tooltipClassName?: string;
  followCursor?: boolean;
  color?: string;
  position?:
    | 'upperRight'
    | 'upperLeft'
    | 'lowerRight'
    | 'lowerLeft'
    | 'midLeft'
    | 'midRight';
}

export const TooltipDisclaimer: React.FC<PopupDisclaimerProps> = ({
  className,
  disclaimer,
  customTrigger,
  customContent,
  contentClassName,
  triggerClassName,
  tooltipClassName,
  followCursor,
  color,
  children,
}) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({
    followCursor,
    placement: 'top',
    offset: [0, 20],
  });

  const createTriggerElementFromText = (
    text: string,
    disclaimerOnly = false
  ) => {
    return (
      <span
        ref={setTriggerRef}
        className={cn(styles.tooltipTrigger, triggerClassName)}
        style={{ color: disclaimerOnly ? color || `#${colorPrimary}` : color }}
      >
        {text}
      </span>
    );
  };

  return (
    <>
      <div className={cn(styles.tooltipDisclaimer, className)}>
        <div
          className={cn(styles.tooltipWrapper, {
            [`${contentClassName}`]: !!contentClassName,
          })}
        >
          {customContent ? (
            <>
              {children}
              {!!customTrigger ? (
                typeof customTrigger === 'string' ? (
                  createTriggerElementFromText(customTrigger)
                ) : (
                  <span ref={setTriggerRef}>{customTrigger}</span>
                )
              ) : (
                disclaimer && createTriggerElementFromText('*', true)
              )}
            </>
          ) : (
            <p>
              {children}
              {!!customTrigger ? (
                typeof customTrigger === 'string' ? (
                  createTriggerElementFromText(customTrigger)
                ) : (
                  <span ref={setTriggerRef}>{customTrigger}</span>
                )
              ) : (
                disclaimer && createTriggerElementFromText('*', true)
              )}
            </p>
          )}
        </div>
      </div>

      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className: `tooltip-container ${cn(
              styles.tooltipContainer,
              tooltipClassName
            )}`,
          })}
        >
          <div
            {...getArrowProps({
              className: `tooltip-arrow ${styles.tooltipArrow}`,
            })}
          />
          <p dangerouslySetInnerHTML={{ __html: disclaimer || '' }} />
        </div>
      )}
    </>
  );
};

export { usePopperTooltip };
